// extracted by mini-css-extract-plugin
export default {"BookRatingForm":"BookRatingForm_BookRatingForm__jkg0K","Stars":"BookRatingForm_Stars__ZCi7D"};